import React from 'react';
import { Routes, Route } from 'react-router-dom';
import WelcomePage from './pages/WelcomePage';
import HomePage from './pages/HomePage';
import ProtectedRoute from './ProtectedRoute';
import NavBar from './components/NavBar/NavBar';

function App() {
  return (
    <div style={{ backgroundColor: 'black' }}>
      <Routes>
        {/* Public Route */}
        <Route path='/welcome' element={<WelcomePage />} />

        {/* Protected Routes */}
        <Route
          path='/'
          element={
            <ProtectedRoute>
              <NavBar
                handleClick={(id) => {
                  const section = document.getElementById(id);
                  section.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                  });
                }}
              />
              <HomePage />
            </ProtectedRoute>
          }
        />
      </Routes>
    </div>
  );
}

export default App;
